import { PlayingCardFace } from "./PlayingCardFace";

type Props = {
  value: string;
  suit: string;
};

/** Shared styled card face (used by RummyTable and anywhere else that used the old SVG URL). */
export const Card = ({ value, suit }: Props) => (
  <PlayingCardFace rankCode={value} suitCode={suit} widthPx={72} />
);
